export function prettyPrint(logItem: Record<any, any> | any[]) {
  console.log(JSON.stringify(logItem, undefined, 2))
}
